module.exports = __webpack_public_path__ + "img/57.9ff8d858.jpg";